var map = {
	"./1.png": 1451,
	"./Bdo.jpg": 3883,
	"./ChatGPT Image Jul 29, 2026, 09_29_04 PM.png": 3041,
	"./Cimb.jpg": 1857,
	"./Cognexa-Platform.png": 2777,
	"./Gotyme.jpg": 2257,
	"./Gotyme.png": 9369,
	"./Maribank.jpg": 6655,
	"./Project/Baranngay.png": 6877,
	"./Project/BhayeMindoro.png": 4371,
	"./Project/Boardmate.png": 1987,
	"./Project/Cognexa.png": 6331,
	"./Project/EgovRms.png": 8427,
	"./Project/Jama.png": 5255,
	"./Project/Liftup.png": 630,
	"./Project/Linktree.png": 5150,
	"./Project/Nexus.png": 4225,
	"./Project/Ojtsyc.png": 8770,
	"./Project/Pamatok.png": 763,
	"./Project/Safepath.png": 4640,
	"./Project/Saripios.png": 2774,
	"./Project/Sibol.png": 8431,
	"./Project/SkSolutions.png": 8782,
	"./Project/Storylens.png": 5651,
	"./Project/ToolTrack.png": 99,
	"./Project/Ugnay.png": 440,
	"./Project/Upmark.png": 4730,
	"./Project/YseriesHub.png": 501,
	"./Project/owepal.png": 2492,
	"./Project/printnconnect.png": 5025,
	"./Unodigibank.jpg": 1105,
	"./deanslist1.jpg": 8220,
	"./deanslist2.jpg": 9739,
	"./deanslist3.jpg": 3902,
	"./deanslist4.jpg": 7317,
	"./info-pages.css": 318,
	"./liftup.png": 2044,
	"./logo.png": 3153,
	"./maya.jpg": 4564,
	"./portfolio.png": 6006,
	"./profile2.jpg": 9611,
	"./profile3.jpg": 1566,
	"./safepath.png": 3122,
	"./safepath1.png": 3505,
	"./trabahanap.png": 202,
	"./yserieshub.png": 1159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;